import { Component, Input, OnInit } from '@angular/core';
import { ReactiveFormsModule, ControlContainer, FormGroupDirective, FormControl, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CheckboxFormFieldComponent } from '../fields/checkbox-form-field/checkbox-form-field.component';
import { DatepickerFormFieldComponent } from '../fields/datepicker-form-field/datepicker-form-field.component';
import { InputFormFieldComponent } from '../fields/input-form-field/input-form-field.component';
import { DropdownTypeEnum } from 'app/shared/enums/dropdowns.enum';
import { ConfigurationSelectFormFieldComponent } from '../fields/configuration-select-form-field/configuration-select-form-field.component';

@Component({
  selector: 'app-case-record-stc-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    InputFormFieldComponent,
    DatepickerFormFieldComponent,
    CheckboxFormFieldComponent,
    TranslateModule,
    ConfigurationSelectFormFieldComponent,
  ],
  templateUrl: './case-record-stc-form.component.html',
  styleUrl: './case-record-stc-form.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class CaseRecordStcFormComponent implements OnInit {
  @Input() viewMode!: boolean;

  dropdownStcRegionLocationType = DropdownTypeEnum.STC_COMPLEX;
  isStcRegionRequired = false;

  form: any;

  constructor(
    public mainForm: FormGroupDirective
  ) {}

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    this.form = this.mainForm.form;

    this.form.addControl('engageStc', new FormControl(false, []));
    this.form.addControl('stcRegionLocation', new FormControl(null, []));
    this.form.addControl('engageStcDate', new FormControl({ value: null, disabled: true }, []));
    this.form.addControl('stcAdditionalInfo', new FormControl(null, []));

    this.form.get('engageStc')?.valueChanges.subscribe((checked: boolean) => {
    const stcRegionCtrl = this.form.get('stcRegionLocation');
    this.isStcRegionRequired = checked;

    if (checked) {
      stcRegionCtrl?.setValidators([Validators.required]);
    } else {
      stcRegionCtrl?.clearValidators();
    }

    stcRegionCtrl?.updateValueAndValidity();
  });
  }
}
